const appConfig = {
	DEV_MODE: false,
	BUILD_VERSION: 'bcd4fa58',
	ERROR_TIME: 20000,
	RETRY_COUNT: 3,
	VOUCHER_REQUIRED_TO_SIGNUP: false,
};

export default appConfig;
